import React, { useEffect,useState } from "react";
import { useNavigate } from "react-router-dom";
import '../../../assets/css/Ucollection.css'
import BlessnavBar from "../BlessnavBarComp/BlessnavBar";
import BlessFooter from "../BlessFooter/BlessFooter";
import apiService from "../../../ApiServices/ApiServices";
import Pagination from "../../PaginationComp/Pagination";

const BlessCollectionList = () => {
    const navigate = useNavigate();
    const [products, setProducts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
  
    useEffect(() => {
      fetchProducts(currentPage);
      window.scrollTo(0, 0);
    }, [currentPage]);
  
    const fetchProducts = async (page) => {
      try {
        const response = await apiService.get(process.env.REACT_APP_API_URL, {
          params: {
            brand_id: 2,  // Brand-wise filter
            // category_id: 1, 
            limit: 10, // Pagination limit
            page: page // Page number
          }
        });
        
        setProducts(response.data.data);
        setLastPage(response.data.last_page);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
  
    const handleProductClick = (product) => {
      navigate(`/bless/collections/product/${product.id}`, { state: { product } });
    };
  
    const handlePageChange = (page) => {
      if (page >= 1 && page <= lastPage) {
        setCurrentPage(page);
      }
    };

    return (
        <>
            <BlessnavBar />
            <div className="collection-container">
                <h2 className="collection-title">Collection</h2>

                <div className="collection-grid">
                {products.length > 0 ? (
            products.map((product) => (
              <div key={product.id} className="collection-item" onClick={() => handleProductClick(product)}>
                <img src={`https://admin.utharamenon.com/storage/${product.product_images[0]?.image_url}`} alt={product.name} className="ucollection-image" />
                <div className="product-title">
                <h3 className="product-name">{product.name}</h3>
                <p className="product-price">Rs. {product.price}</p>
                </div>
              </div>
            ))
          ) : (
            <p className="no-products">No products available</p>
          )}
                </div>

                {/* <button className="shop-button">Shop Collection &gt;</button> */}

                  {/* Pagination Component */}
        <Pagination
          totalPages={lastPage}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
            </div>
            {/* <Footer /> */}
            <BlessFooter />
        </>
    );
};

export default BlessCollectionList